import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { axiosAuth } from "../config/axiosInstance";
import { PERSONALISED_VIDEO_PLAYER_BACKEND_BASE_URL } from "../config/api_config";
import { resolveCourseId, resolveModuleSlug } from "../utilities/videoPlayerApi";

export const fetchChats = createAsyncThunk(
    'askCreator/fetchChats',
    async ({ course_id, module_slug, lesson_id }, { getState }) => {
        const courseId = resolveCourseId(getState(), course_id);
        const moduleSlug = resolveModuleSlug(module_slug);
        const response = await axiosAuth.get(
            `${PERSONALISED_VIDEO_PLAYER_BACKEND_BASE_URL}/api/v1/courses/${courseId}/modules/${moduleSlug}/lessons/${lesson_id}/chat`
        );
        return response.data;
    }
);

export const fetchLastChat = createAsyncThunk(
    'askCreator/fetchLastChat',
    async ({ course_id, module_slug, video_id, lesson_id, query }, { getState }) => {
        const courseId = resolveCourseId(getState(), course_id);
        const moduleSlug = resolveModuleSlug(module_slug);
        const response = await axiosAuth.post(
            `${PERSONALISED_VIDEO_PLAYER_BACKEND_BASE_URL}/api/v1/courses/${courseId}/modules/${moduleSlug}/lessons/${lesson_id}/chat/messages`,
            { message: query, video_id: video_id || null }
        );
        return response.data;
    }
);

const askCreatorSlice = createSlice({
    name: 'askCreator',
    initialState: {
        chat_history: [],
        loadingMessage: false,
        limit_reached: false,
        limit_count: 5,
        error: null,
    },
    reducers: {
        addLatestQuestion: (state, action) => {
            state.chat_history = [...state.chat_history, action.payload];
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchChats.pending, (state) => {
                state.error = null;
            })
            .addCase(fetchChats.fulfilled, (state, action) => {
                state.chat_history = action.payload?.chat_history ?? [];
            })
            .addCase(fetchChats.rejected, (state, action) => {
                state.error = action.error;
            })
            .addCase(fetchLastChat.pending, (state) => {
                state.loadingMessage = true;
                state.error = null;
            })
            .addCase(fetchLastChat.fulfilled, (state, action) => {
                state.loadingMessage = false;
                state.limit_reached = action.payload?.limit_reached;
                state.limit_count = action.payload?.limit_count;

                if (action.payload?.limit_reached) {
                    state.chat_history.push({
                        role: "system",
                        content: `You have reached your daily limit of ${action.payload.limit_count} doubts. To unlock unlimited doubt solving upgrade to LearnTubeX.`,
                    });
                    return;
                }

                const assistantEntry = [...(action.payload?.chat_history || [])]
                    .reverse()
                    .find((entry) => entry.role === 'assistant') || {
                        role: 'assistant',
                        content: action.payload?.response || '',
                    };
                state.chat_history.push(assistantEntry);
            })
            .addCase(fetchLastChat.rejected, (state, action) => {
                state.loadingMessage = false;
                state.error = action.error;
            });
    },
});

export const { addLatestQuestion } = askCreatorSlice.actions;
export const selectChats = (state) => state.askCreator;
export default askCreatorSlice.reducer;
